// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".c-repository-list__list-item{padding-top:var(--spacing-5)}@media (min-width:40em){.c-repository-list__list-item{padding-top:0}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
